import {
    ADD_COUNTRIES,
    ADD_TIMEZONES,
    ADD_LANGUAGES,
    ENQUEUE_SNACKBAR,
    REMOVE_SNACKBAR,
    SET_IS_NANO,
    SET_HAS_SETUP
} from './appActionTypes';

export const addCountries = Countries => ({
    type: ADD_COUNTRIES,
    payload: { Countries }
});

export const addTimezones = Timezones => ({
    type: ADD_TIMEZONES,
    payload: { Timezones }
});

export const addLanguages = Languages => ({
    type: ADD_LANGUAGES,
    payload: { Languages }
});

export const enqueueSnackbar = notification => ({
    type: ENQUEUE_SNACKBAR,
    payload: {
        notification: {
            key: new Date().getTime() + Math.random(),
            ...notification
        }
    }
});

export const removeSnackbar = key => ({
    type: REMOVE_SNACKBAR,
    payload: { key }
});

export const setIsNano = isNano => ({
    type: SET_IS_NANO,
    payload: { isNano }
});

export const setHasSetup = hasSetup => ({
    type: SET_HAS_SETUP,
    payload: { hasSetup }
});
